import PropTypes from 'prop-types';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setEditModalId } from 'redux/matriculadosSlice';
import ButtonActive from 'utils/buttons/ButtonActive';
import ButtonDisable from 'utils/buttons/ButtonDisable';
import ButtonEdit from 'utils/buttons/ButtonEdit';
import ButtonResend from 'utils/buttons/ButtonResend';
import ActiveMatriculadoModal from '../modals/ActiveMatriculadoModal';
import DisableMatriculadoModal from '../modals/DisableMatriculadoModal';
import ResendMatriculadoModal from '../modals/ResendMatriculadoModal';
import ButtonView from 'utils/buttons/ButtonView';
import { useNavigate } from 'react-router-dom';
export const MatriculadosActions = ({
  matriculados,
  switchNewUser,
  setSwitchNewUser
}) => {
  const dispatch = useDispatch();
  const userLogged = useSelector(state => state.login.currentUser);
  const navigate = useNavigate();

  const [userSelected, setUserSelected] = useState({});
  const [disableActiveModal, setDisableModal] = useState(false);
  const [activeAllowModal, setActiveModal] = useState(false);
  const [resendModal, setResendModal] = useState(false);

  const openDisableModal = user => {
    setUserSelected(user);
    setDisableModal(true);
  };

  const openActiveUser = user => {
    setUserSelected(user);
    setActiveModal(true);
  };

  const openResendModal = user => {
    setUserSelected(user);
    setResendModal(true);
  };

  return (
    <>
      <span className="d-flex gap-2">
        <ButtonView
          funcion={matricId => navigate(`/admin/ver-inmobiliaria/${matricId}`)}
          data={matriculados.matricula}
        />

        <ButtonEdit
          funcion={() => dispatch(setEditModalId(matriculados.id))}
          data={matriculados.id}
          disabled={userLogged.typeOfUser !== 'cucicba'}
        />

        {matriculados.bypassed && (
          <ButtonDisable
            funcion={openDisableModal}
            data={matriculados}
            disabled={userLogged.typeOfUser !== 'cucicba'}
          />
        )}

        {!matriculados.bypassed && (
          <ButtonActive
            funcion={openActiveUser}
            data={matriculados}
            disabled={userLogged.typeOfUser !== 'cucicba'}
          />
        )}
        <ButtonResend
          funcion={() => {
            openResendModal(matriculados);
          }}
          data={matriculados}
          disabled={userLogged.typeOfUser !== 'cucicba'}
        />
      </span>
      {activeAllowModal && (
        <ActiveMatriculadoModal
          show={activeAllowModal}
          setShow={setActiveModal}
          user={userSelected}
        />
      )}
      {disableActiveModal && (
        <DisableMatriculadoModal
          show={disableActiveModal}
          setShow={setDisableModal}
          user={userSelected}
          switchNewUser={switchNewUser}
          setSwitchNewUser={setSwitchNewUser}
        />
      )}
      {resendModal && (
        <ResendMatriculadoModal
          show={resendModal}
          setShow={setResendModal}
          user={userSelected}
          switchNewUser={switchNewUser}
          setSwitchNewUser={setSwitchNewUser}
        />
      )}
    </>
  );
};
MatriculadosActions.propTypes = {
  matriculados: PropTypes.object.isRequired,
  switchNewUser: PropTypes.bool.isRequired,
  setSwitchNewUser: PropTypes.func.isRequired
};
